import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { StreetInput } from './StreetInput';

export function StreetField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return <GenericInputField<TValues> {...props} Input={StreetInput} />;
}
